var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 20,
    height: 13,
    rx: 2,
    fill: "#4EDF91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.756 23.127a1 1 0 01-1.512 0l-3.007-3.472A1 1 0 0111.993 18h6.014a1 1 0 01.756 1.655l-3.007 3.472z",
    fill: "#4EDF91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M15 11v6M18 14h-6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4EDF91",
    fillOpacity: 0.2
  })));
}
export default SvgRequests;